import { useMemo, type ReactNode } from 'react';
import { useAvailableFieldsWithTypes } from '../../engage-segments-tab/useSegmentTemplates';
import { SegmentSchemaCatalogContext } from './segment-schema-catalog-context';

interface SegmentSchemaCatalogProviderProps {
  children: ReactNode;
}

/** Supply one schema catalog to every condition component in a visual builder. */
export function SegmentSchemaCatalogProvider({ children }: SegmentSchemaCatalogProviderProps) {
  const { data: schemaCatalog, isLoading, isFetching, error, refetch } = useAvailableFieldsWithTypes();
  const value = useMemo(() => {
    const schemasById = new Map(schemaCatalog?.schemas.map(schema => [schema.id, schema]));
    const getSchemaById = (schemaId: string) => schemasById.get(schemaId);
    return {
      schemaCatalog,
      isLoading,
      isRetrying: isFetching,
      error,
      retry: () => void refetch(),
      getSchemaById,
    };
  }, [schemaCatalog, isLoading, isFetching, error, refetch]);
  return (
    <SegmentSchemaCatalogContext.Provider value={value}>{children}</SegmentSchemaCatalogContext.Provider>
  );
}
